import { render, staticRenderFns } from "./invoicePurchaser.vue?vue&type=template&id=2b0ce7f6&"
import script from "./invoicePurchaser.vue?vue&type=script&lang=js&"
export * from "./invoicePurchaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports